<div class="editor-page">
  <div class="container-xxl editor">
    <header class="editor-head">
      <div class="editor-banner">
        <img src="assets/img/contactBar.png" alt="">
        <h1>Gestione autorizzazioni</h1>
      </div>
      <p class="editor-lead">Assegna l'accesso alle pagine per ogni utente.</p>
    </header>

    <form class="editor-form" [formGroup]="userForm">
      <section class="editor-panel">
        <h2>Utente</h2>
        <div class="field-block">
          <label for="userId">Seleziona utente</label>
          <select id="userId" class="field" formControlName="id">
            <option [ngValue]="null" disabled>Seleziona utente</option>
            @for (option of usersList; track option.id) {
              <option [ngValue]="option.id">{{ option.nickname }} - {{ option.email }}</option>
            }
          </select>
        </div>
      </section>
    </form>

    @if (userForm.get('id')?.value) {
      <form class="editor-form" [formGroup]="authorizationsForm">
        <section class="editor-panel">
          <h2>Pagine</h2>

          @if (authorizations.length === 0) {
            <p class="editor-hint">Nessuna pagina in elenco per questo utente.</p>
          } @else {
            <div class="auth-list" formArrayName="authorizations">
              @for (authorization of authorizations.controls; track authorization.get('idcomponent')?.value; let i = $index) {
                <div class="auth-row" [formGroupName]="i"
                  [class.is-always]="authorization.get('view_always')?.value == 1">
                  <div class="auth-identity">
                    <div class="auth-title-line">
                      <span class="auth-name">
                        {{ authorization.get('page_name')?.value || authorization.get('component_name')?.value || '—' }}
                      </span>
                      @if (authorization.get('view_always')?.value == 1) {
                        <span class="status-badge">Sempre visibile</span>
                      }
                    </div>
                    <span class="auth-meta">
                      ID {{ authorization.get('idcomponent')?.value }}
                      · {{ authorization.get('type')?.value === 0 ? 'Pagina' : authorization.get('type')?.value }}
                      · {{ authorization.get('component_name')?.value }}
                    </span>
                    <span class="auth-path">{{ authorization.get('path')?.value }}</span>
                  </div>

                  @if (authorization.get('view_always')?.value != 1) {
                    <div class="auth-toggles">
                      <label class="check-field">
                        <input type="checkbox" formControlName="authorization">
                        <span>Autorizzazione</span>
                      </label>
                      <label class="check-field">
                        <input type="checkbox" formControlName="readonly">
                        <span>Readonly</span>
                      </label>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </section>

        <div class="editor-actions">
          <button class="editor-save" type="button" (click)="save()">Salva</button>
        </div>
      </form>
    }
  </div>
</div>
